import {
  HStack,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  ModalProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { PaymentProofInterface } from "../../constants/Transaction";
import useCustomToast from "../../lib/useCustomToast";
import { axiosBuyer } from "../../utils/AxiosInstance";
import { ModalTitle } from "../card/ModalTitle";
import { SpinnerLoading } from "../spinner/SpinnerLoading";

interface Props extends ModalProps {
  isOpen: boolean;
  onOpen: VoidFunction;
  onClose: VoidFunction;
  orderId: any;
  invoice: string | undefined;
}

export const PaymentProofModal = ({
  isOpen,
  onOpen,
  onClose,
  orderId,
  invoice,
  ...rest
}: Props) => {
  const [data, setData] = useState<PaymentProofInterface | undefined>(
    undefined
  );
  const [loaded, setLoaded] = useState<boolean>(false);
  const toast = useCustomToast();

  useEffect(() => {
    if (isOpen) {
      setLoaded(false);
      setData(undefined);

      axiosBuyer
        .get(`/v1/buyer/payment-proof/${orderId}`)
        .then((res) => {
          setData(res.data.data);
        })
        .catch((err) => {
          toast({
            description: err?.response?.data?.message || "",
          });
        })
        .finally(() => {
          setLoaded(true);
        });
    }
  }, [isOpen]);

  return (
    <Modal size={"xl"} isOpen={isOpen} onClose={onClose} {...rest}>
      <ModalOverlay />

      <ModalContent>
        <ModalCloseButton />

        <ModalBody>
          {!loaded ? (
            <SpinnerLoading />
          ) : (
            <VStack w={"100%"} align={"stretch"}>
              <ModalTitle
                title="Bukti Pembayaran"
                subtitle={`Nomor Invoice : ${invoice}`}
              />

              <Image
                w={"100%"}
                mx={"auto"}
                src={
                  data?.buyer.image
                    ? `${process.env.REACT_APP_MEDIA_URL}${data?.buyer.image}`
                    : ""
                }
                alt={data?.buyer.image || "Image Buyer"}
                fallbackSrc="/assets/svg/illustration_empty.svg"
                objectFit={"contain"}
                objectPosition={"center"}
              />

              <VStack w={"100%"} mt={4} gap={1} align={"stretch"}>
                <Text textStyle={"b-reg-sb"}>
                  #Rekening Admin Yang Dipilih :{" "}
                </Text>

                <HStack w={"100%"} justify={"space-between"}>
                  <Text textStyle={"b-reg"}>Jenis Bank :</Text>

                  <Text textStyle={"b-reg-sb"}>{data?.admin.bank_name}</Text>
                </HStack>

                <HStack w={"100%"} justify={"space-between"}>
                  <Text textStyle={"b-reg"}>a/n : </Text>

                  <Text textStyle={"b-reg-sb"}>{data?.admin.acc_name}</Text>
                </HStack>

                <HStack w={"100%"} justify={"space-between"}>
                  <Text textStyle={"b-reg"}>Rekening : </Text>

                  <Text textStyle={"b-reg-sb"}>{data?.admin.acc_number}</Text>
                </HStack>
              </VStack>

              <VStack w={"100%"} mt={4} gap={1} align={"stretch"}>
                <Text textStyle={"b-reg-sb"}>#Dikirim Oleh :</Text>

                <HStack w={"100%"} justify={"space-between"}>
                  <Text textStyle={"b-reg"}>Jenis Bank :</Text>

                  <Text textStyle={"b-reg-sb"}>{data?.buyer.bank_name}</Text>
                </HStack>

                <HStack w={"100%"} justify={"space-between"}>
                  <Text textStyle={"b-reg"}>a/n : </Text>

                  <Text textStyle={"b-reg-sb"}>{data?.buyer.acc_name}</Text>
                </HStack>
              </VStack>
            </VStack>
          )}
        </ModalBody>

        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};
